import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHEstablecimientoDel = async (credentials, data) => {
    const body = {
        service: "RNHEstablecimientoDel",
        params: {
            rnhEstablecimientoId: data?.id,
            rnhEstablecimientoVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
